import React, { useState } from 'react';
import { Box, Typography, Button, Container, IconButton, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { isValidIndianMobile, PORTAL_PENDING_PHONE_KEY, readStorage, writeStorage } from './portalAuth';
import StickyActionBar, { fullScreenHeight } from '../../components/common/StickyActionBar';

export default function PortalLoginPage() {
  const navigate = useNavigate();
  // Prefill with the number used on the register step
  const [phone, setPhone] = useState(() => readStorage('local', 'phone') || '');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');

    if (phone.length !== 10) {
      setErrorMessage('Please enter a valid 10-digit phone number');
      return;
    }
    if (!isValidIndianMobile(phone)) {
      setErrorMessage('Phone number must start with 6, 7, 8, or 9');
      return;
    }

    writeStorage('session', PORTAL_PENDING_PHONE_KEY, phone);
    navigate('/portal/otp', { state: { phone } });
  };

  return (
    <Box sx={{ ...fullScreenHeight, bgcolor: '#F2F5F1', p: 2, pb: 0, display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="sm" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>

        {/* Top Bar */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, pt: 2 }}>
          <IconButton onClick={() => navigate(-1)} sx={{ color: '#000', p: 0 }}>
            <ArrowBackIosNewIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>

        {/* Headings */}
        <Typography sx={{ color: '#0F231A', fontSize: '32px', fontWeight: 700, lineHeight: 1.1, mb: 1, fontFamily: '"Moan Slight", sans-serif', letterSpacing: '-1px' }}>
          Log in to your portal
        </Typography>
        <Typography sx={{ color: '#666', fontSize: '15px', mb: 4, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
          We'll send a one-time password to this number.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, flexGrow: 1 }}>

          {errorMessage && (
            <Alert severity="error" onClose={() => setErrorMessage('')} sx={{ borderRadius: '12px' }}>
              {errorMessage}
            </Alert>
          )}

          {/* Mobile number */}
          <Box>
            <Typography sx={{ color: '#000', fontSize: '14px', fontWeight: 700, mb: 1, fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
              Mobile number
            </Typography>
            <Box sx={{ display: 'flex', border: '1px solid #ddd', borderRadius: '12px', bgcolor: '#fff', overflow: 'hidden' }}>
              <Box sx={{ px: 2, py: 1.5, borderRight: '1px solid #ddd', display: 'flex', alignItems: 'center', color: '#666', fontWeight: 600, fontSize: '15px', fontFamily: '"Plus Jakarta Sans", sans-serif' }}>
                +91
              </Box>
              <input
                type="tel"
                inputMode="numeric"
                autoComplete="tel-national"
                placeholder="98765 43210"
                maxLength={10}
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                style={{ flex: 1, minWidth: 0, border: 'none', padding: '12px 16px', fontSize: '16px', outline: 'none', fontFamily: '"Plus Jakarta Sans", sans-serif' }}
              />
            </Box>
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <StickyActionBar>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={phone.length !== 10}
              sx={{
                bgcolor: '#0F763F !important',
                color: '#fff',
                py: 2,
                borderRadius: '16px',
                fontSize: '17px',
                fontWeight: 700,
                textTransform: 'none',
                boxShadow: 'none',
                fontFamily: '"Plus Jakarta Sans", sans-serif',
                '&:hover': { bgcolor: '#0d6535 !important', boxShadow: 'none' },
                '&:disabled': { bgcolor: '#A5D6B6 !important', color: '#fff' }
              }}
            >
              Send OTP
            </Button>
          </StickyActionBar>
        </Box>
      </Container>
    </Box>
  );
}
